import { ButtonHTMLAttributes } from "react";

interface LiffButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {}

export default function LiffButton({
  className = "",
  ...props
}: LiffButtonProps) {
  return (
    <button
      type="button"
      className={[
        "h-[60px] w-[340px] rounded-[4px]",
        "text-[24px] font-semibold tracking-[0.5px] text-white",
        "cursor-pointer bg-[#0068B7]",
        "disabled:cursor-not-allowed disabled:bg-[#CCCCCC]",
        className,
      ].join(" ")}
      {...props}
    />
  );
}
